<!-- vertical-stepper.component.html -->
<aside class="vs-sidebar">
  <nav class="flex flex-row lg:flex-col gap-1.5 lg:gap-1 overflow-x-auto lg:overflow-y-auto
              pb-2 lg:pb-0 -mx-4 px-4 lg:mx-0 lg:px-0 lg:sticky lg:top-0 lg:max-h-screen lg:py-0">

    @for (step of steps(); track step.title; let i = $index) {
      @let state = stepStates()[i];
      <button
        type="button"
        (click)="onStepClick(i)"
        [id]="'step-nav-btn-' + i"
        [attr.aria-current]="state.active ? 'step' : null"
        [class.active]="state.active"
        [class.completed]="state.completed"
        [class.has-error]="state.hasError"
        [class.locked]="i > maxVisitedStep()"
        class="vs-nav-item">

        <!-- Step indicator circle -->
        <div class="vs-indicator">
          @if (state.completed) {
            <i class="pi pi-check text-xs font-bold"></i>
          } @else if (state.hasError) {
            <i class="pi pi-exclamation-triangle text-xs"></i>
          } @else {
            <span class="text-xs font-bold">{{ i + 1 }}</span>
          }
        </div>

        <!-- Step label (hidden on mobile, visible on lg+) -->
        <div class="hidden lg:flex flex-col items-start min-w-0 flex-1 overflow-hidden">
          <span class="vs-label w-full">{{ step.title }}</span>
        </div>

        <!-- Mobile: compact step title below indicator -->
        <span class="lg:hidden text-xs font-semibold text-center leading-tight mt-0.5
                     whitespace-nowrap truncate max-w-[64px]">
          {{ step.title }}
        </span>

      </button>
    }

  </nav>
</aside>
